import { CCC } from './../../models/CCCFeed';
import { Observable } from 'rxjs/Observable';
import { PriceFeedProvider } from './../../providers/price-feed/price-feed';
import { Exchange } from './../../models/Exchanges';
import { Component, Input } from '@angular/core';

/**
 * Generated class for the DisplayPriceComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'display-price',
  templateUrl: 'display-price.html'
})
export class DisplayPriceComponent {

  @Input('pair') pair: string;
  @Input('exchange') exchange: Exchange;

  ticker: Observable<CCC.Ticker>;
  constructor(public priceFeed: PriceFeedProvider) {

  }

  ngOnInit(){
    let symbols = this.pair.split('/');
    this.ticker = this.priceFeed.getTicker(this.exchange.name, symbols[0], symbols[1]);
  }

}



// WEBPACK FOOTER //
// ./src/components/display-price/display-price.ts